module.exports = __webpack_public_path__ + "fonts/AvenirBold.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/AvenirBold.woff
// module id = 479
// module chunks = 12